import { BackDrop } from "./back-drop.styled";
import { Ellipsis } from "./spinner";

interface LoadingBackDropProps {
  loading: boolean;
}

export const LoadingBackDrop = ({ loading }: LoadingBackDropProps) => {
  return (
    <BackDrop open={loading}>
      <Ellipsis />
    </BackDrop>
  );
};
